import 'babel-polyfill'; // support IE11 and below
import 'raf/polyfill'; // support IE9?
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js